import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

interface SessionExpiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SessionExpiredModal({ isOpen, onClose }: SessionExpiredModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleBackToLogin = () => {
    logout();
    onClose();
    navigate('/admin/login');
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-lock-fill me-2 text-warning"></i>
              {t('session.expired_title', 'Session Expired')}
            </h5>
          </div>
          <div className="modal-body">
            <p className="mb-0">
              {t('session.expired_message', 'Your session has expired. Please log in again.')}
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleBackToLogin}
            >
              <i className="bi bi-box-arrow-left me-2"></i>
              {t('session.back_to_login', 'Back to Login')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
